import { Attachment } from "../../../domain/model/Attachment";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { UploadFileRepository } from "./UploadFileRepository";

export class UploadFileRepositoryImpl implements UploadFileRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  uploadFile(fileFormData: FormData): Promise<Response<Attachment>> {
    return this.apiService.uploadFile(fileFormData);
  }
  uploadMultipleFiles(
    filesFormData: FormData
  ): Promise<Response<Array<string>>> {
    return this.apiService.uploadMultipleFiles(filesFormData);
  }
}
